import type { ReactDiffViewerStylesOverride } from 'react-diff-viewer-continued';

export const diffViewerStyles: ReactDiffViewerStylesOverride = {
  variables: {
    light: {
      diffViewerBackground: '#fff',
      diffViewerColor: '#212529',
      addedBackground: '#e6ffed',
      addedColor: '#24292e',
      removedBackground: '#ffeef0',
      removedColor: '#24292e',
      wordAddedBackground: '#acf2bd',
      wordRemovedBackground: '#fdb8c0',
      addedGutterBackground: '#cdffd8',
      removedGutterBackground: '#ffdce0',
      gutterBackground: '#f7f7f7',
      gutterBackgroundDark: '#f3f3f3',
      highlightBackground: '#fffbdd',
      highlightGutterBackground: '#fff5b1',
    },
    dark: {
      diffViewerBackground: '#2e3440',
      diffViewerColor: '#eceff4',
      addedBackground: '#144620',
      addedColor: '#e6ffed',
      removedBackground: '#481a1e',
      removedColor: '#ffeef0',
      wordAddedBackground: '#176f2c',
      wordRemovedBackground: '#691c24',
      addedGutterBackground: '#0e3218',
      removedGutterBackground: '#3c1113',
      gutterBackground: '#2e3440',
      gutterBackgroundDark: '#242933',
      highlightBackground: '#4a4340',
      highlightGutterBackground: '#3d3731',
    },
  },
  line: {
    padding: '8px 2px',
    '&:hover': {
      background: '#f8f9fa',
    },
  },
  gutter: {
    padding: '0 10px',
    minWidth: '50px',
  },
  marker: {
    padding: '0 10px',
  },
  wordDiff: {
    padding: '2px',
    display: 'inline',
    letterSpacing: 'normal',
    wordSpacing: 'normal',
  },
  wordAdded: {
    background: 'var(--diffAddedBackground)',
    color: 'var(--diffAddedColor)',
    letterSpacing: 'normal',
    wordSpacing: 'normal',
  },
  wordRemoved: {
    background: 'var(--diffRemovedBackground)',
    color: 'var(--diffRemovedColor)',
    letterSpacing: 'normal',
    wordSpacing: 'normal',
  },
  codeFoldGutter: {
    background: '#dbedff',
  },
  contentText: {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    fontSize: '13px',
    lineHeight: '20px',
    letterSpacing: 'normal',
    wordSpacing: 'normal',
  },
};
